import { useEffect, useState } from 'react';
import { A29, A29Input, A29Output } from 'api/U002';
import { FetchError } from 'api/API';

export function useValidateStatus(
  input: A29Input
): [A29Output | undefined, boolean, Error | null, () => void] {
  const [loading, setLoading] = useState<boolean>(true);
  const [result, setResult] = useState<A29Output>();
  const [err, setError] = useState<Error | null>(null);

  const [refreshCount, setRefreshCount] = useState<number>(0);
  const refresh = () => setRefreshCount(refreshCount + 1);

  const fetchUser = async (input: A29Input, cancellation: AbortSignal) => {
    return await A29(input, cancellation);
  };

  useEffect(() => {
    if (!input.sessionId || !input.status) {
      setLoading(false);
      return;
    }
    const controller = new AbortController();
    const cancellation = controller.signal;
    async function fetch() {
      setLoading(true);
      setError(null);
      try {
        const user = await fetchUser(input, cancellation);
        setResult(user);
      } catch (err) {
        console.error(err);
        setResult(undefined);
        setError(err instanceof Error ? err : new Error(`unknown error. ${err}`));
        if (err instanceof FetchError) {
          const errorData = await err.response.json();
          const flooredError = new Error(errorData.message || `HTTP ERROR: ${err.message}`);
          setError(flooredError);
          console.log({ flooredError });
          return flooredError;
        }
      } finally {
        setLoading(false);
      }
    }

    fetch();
    return () => {
      // controller.abort()
    };
  }, [input.sessionId, input.status]);

  return [result, loading, err, refresh];
}
